/* ===== Fat Burn 360 — Shopify-backed landing (cart/checkout via Shopify) ===== */
(function () {
  var CFG = window.RADO || {};
  var R = CFG.routes || {};
  var CART_ADD = R.cart_add || '/cart/add.js';
  var CART_CHANGE = R.cart_change || '/cart/change.js';
  var CART_GET = (R.cart || '/cart') ; // /cart.js is the JSON endpoint
  var CART_JSON = '/cart.js';
  var CUR = CFG.currency_code || 'PKR';
  function money(cents) { return CFG.currency + Number(Math.round(cents) / 100).toLocaleString(); }
  function track(evt, data) { if (typeof fbq === 'function') fbq('track', evt, data || {}); }

  /* ---- Gallery ---- */
  var imgs = CFG.images || [];
  var idx = 0;
  var mainImg = document.getElementById('mainImg');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.g-thumbs img'));
  function showImg(i) {
    if (!imgs.length) return;
    idx = (i + imgs.length) % imgs.length;
    if (mainImg) {
      mainImg.classList.add('swapping');
      var next = new Image();
      next.onload = function () { mainImg.src = imgs[idx]; mainImg.classList.remove('swapping'); };
      next.src = imgs[idx];
    }
    thumbs.forEach(function (t, k) { t.classList.toggle('active', k === idx); });
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { showImg(+t.dataset.i); }); });
  var gp = document.getElementById('gPrev'), gn = document.getElementById('gNext');
  if (gp) gp.addEventListener('click', function () { showImg(idx - 1); });
  if (gn) gn.addEventListener('click', function () { showImg(idx + 1); });

  /* ---- Quantity ---- */
  var qInput = document.getElementById('qtyInput');
  var qtyCount = document.getElementById('qtyCount');
  var qmin = Number(CFG.qty_min) || 1, qmax = Number(CFG.qty_max) || 99;
  function clampQty(v) { v = parseInt(v, 10) || qmin; return Math.max(qmin, Math.min(qmax, v)); }
  function syncQty() {
    var q = clampQty(qInput.value); qInput.value = q;
    if (qtyCount) qtyCount.textContent = q + (q === 1 ? ' item' : ' items');
  }
  var dec = document.getElementById('qtyDec'), inc = document.getElementById('qtyInc');
  if (dec) dec.addEventListener('click', function () { qInput.value = clampQty(qInput.value) - 1; syncQty(); });
  if (inc) inc.addEventListener('click', function () { qInput.value = clampQty(qInput.value) + 1; syncQty(); });
  if (qInput) { qInput.addEventListener('input', syncQty); syncQty(); }

  /* ========================================================================
     CART — backed by Shopify AJAX Cart API
     ===================================================================== */
  var drawer   = document.getElementById('cartDrawer');
  var overlay  = document.getElementById('drawerOverlay');
  var itemsBox = document.getElementById('cartItems');
  var emptyBox = document.getElementById('cartEmpty');
  var footBox  = document.getElementById('cartFoot');
  var badge    = document.getElementById('cartCount');
  var busy = false;

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('show');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('show');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function getCart() { return fetch(CART_JSON, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function renderCart(cart) {
    var count = cart ? cart.item_count : 0;
    if (badge) { badge.textContent = count; badge.classList.toggle('show', count > 0); }
    if (!itemsBox) return;
    if (!cart || !cart.items || !cart.items.length) {
      itemsBox.innerHTML = '';
      if (emptyBox) emptyBox.style.display = 'block';
      if (footBox) footBox.style.display = 'none';
      return;
    }
    if (emptyBox) emptyBox.style.display = 'none';
    if (footBox) footBox.style.display = 'block';
    var eachTxt = CFG.each_suffix || 'each';
    itemsBox.innerHTML = cart.items.map(function (it) {
      var itemWord = it.quantity === 1 ? 'item' : 'items';
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1$2') : '';
      return '' +
        '<div class="cart-item">' +
          '<img src="' + img + '" alt="">' +
          '<div class="ci-info">' +
            '<div class="ci-top">' +
              '<div class="ci-name">' + it.product_title + '</div>' +
              '<button type="button" class="ci-remove" data-act="rm" data-key="' + it.key + '">Remove</button>' +
            '</div>' +
            '<div class="ci-price">' + money(it.final_price) + ' ' + eachTxt + '</div>' +
            '<div class="ci-qty">' +
              '<button type="button" data-act="dec" data-key="' + it.key + '" data-q="' + it.quantity + '" aria-label="decrease">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-act="inc" data-key="' + it.key + '" data-q="' + it.quantity + '" aria-label="increase">+</button>' +
            '</div>' +
            '<div class="ci-count">' + it.quantity + ' ' + itemWord + '</div>' +
          '</div>' +
        '</div>';
    }).join('');
    var sE = document.getElementById('cartSubtotal');
    if (sE) sE.textContent = money(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);
  }

  function refresh() { return getCart().then(renderCart); }

  function changeLine(key, quantity) {
    if (busy) return Promise.resolve();
    busy = true;
    return fetch(CART_CHANGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart).finally(function () { busy = false; });
  }

  function addToCart(qty) {
    if (!CFG.variant_id) { alert('Product is currently unavailable.'); return Promise.reject(); }
    qty = clampQty(qty);
    return fetch(CART_ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: CFG.variant_id, quantity: qty }] })
    }).then(function (r) { return r.json(); }).then(function () {
      track('AddToCart', { content_name: CFG.product_name, content_type: 'product', value: (CFG.special_price || 0) * qty, currency: CUR });
      return refresh();
    });
  }

  // Item qty / remove (event delegation)
  if (itemsBox) {
    itemsBox.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-act]');
      if (!btn) return;
      var key = btn.dataset.key, act = btn.dataset.act, q = parseInt(btn.dataset.q, 10) || 1;
      if (act === 'inc') changeLine(key, q + 1);
      else if (act === 'dec') changeLine(key, q - 1);
      else if (act === 'rm') changeLine(key, 0);
    });
  }

  // Buttons
  var addBtn = document.getElementById('addToCartBtn');
  var buyBtn = document.getElementById('buyNowBtn');
  var cartIcon = document.getElementById('cartIconBtn');
  if (addBtn) addBtn.addEventListener('click', function () {
    addToCart(qInput ? qInput.value : 1).then(openDrawer).catch(function () {});
  });
  if (buyBtn) buyBtn.addEventListener('click', function () {
    buyBtn.disabled = true;
    addToCart(qInput ? qInput.value : 1).then(function () { window.location.href = '/checkout'; }).catch(function () { buyBtn.disabled = false; });
  });
  if (cartIcon) cartIcon.addEventListener('click', openDrawer);

  /* Attention shake on "Add to Cart" every 2s (pauses while cart open) */
  if (addBtn) {
    setInterval(function () {
      if (drawer && drawer.classList.contains('open')) return;
      addBtn.classList.add('shake');
      setTimeout(function () { addBtn.classList.remove('shake'); }, 650);
    }, 2000);
  }

  var cartClose = document.getElementById('cartClose');
  if (cartClose) cartClose.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  var contShop = document.getElementById('continueShopping');
  if (contShop) contShop.addEventListener('click', closeDrawer);
  var goCk = document.getElementById('goCheckout');
  if (goCk) goCk.addEventListener('click', function () { window.location.href = '/checkout'; });

  refresh();

  /* ========================================================================
     LIVE SOCIAL PROOF
     ===================================================================== */
  var sp = CFG.social_proof || {};
  var spBox = document.getElementById('socialProof');
  if (spBox && sp.enabled && sp.orders && sp.orders.length) {
    var orders = sp.orders, oi = 0;
    var nameEl = document.getElementById('spName');
    var cityEl = document.getElementById('spCity');
    var timeEl = document.getElementById('spTime');
    var closed = false;
    var spClose = document.getElementById('spClose');
    if (spClose) spClose.addEventListener('click', function () { closed = true; spBox.classList.remove('show'); });
    function randGap() { var secs = [8, 10, 12, 15, 18, 20]; return secs[Math.floor(Math.random() * secs.length)] * 1000; }
    var SHOW_MS = 5000;
    function showProof() {
      if (closed) return;
      var o = orders[oi % orders.length]; oi++;
      if (nameEl) nameEl.textContent = o.name;
      if (cityEl) cityEl.textContent = 'from ' + o.city;
      if (timeEl) timeEl.textContent = (o.mins || 5) + ' minutes ago';
      spBox.classList.add('show');
      setTimeout(function () { spBox.classList.remove('show'); }, SHOW_MS);
      setTimeout(showProof, SHOW_MS + randGap());
    }
    setTimeout(showProof, randGap());
  }
})();
